import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const CrossIcon = ({
  width=27,
  height=28,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 27 28" fill="none">
      <path
        d="M26.298 23.306a2.394 2.394 0 1 1-3.386 3.385L.905 4.685a2.394 2.394 0 1 1 3.386-3.386l22.007 22.007z"
        fill={strokeColor}
      />
      <path
        d="M22.903 1.31a2.394 2.394 0 0 1 3.386 3.387L4.282 26.703a2.394 2.394 0 0 1-3.385-3.385L22.903 1.31z"
        fill={strokeColor}
      />
    </svg>
  )
}

export default CrossIcon
